const XIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icons8-twitterx 1'>
      <path
        id='Vector'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.8334 3L5.29792 21H3.44092L18.9769 3H20.8334Z'
        fill='#FAFAFA'
      />
      <path
        id='Vector_2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.9049 20.5L4.24341 3.5H8.72191L20.3834 20.5H15.9049Z'
        fill='#0E2C37'
      />
      <path
        id='Vector_3'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.19543 4.5L18.4844 19.5H16.4314L6.14243 4.5H8.19543ZM8.98543 3H3.29443L15.6414 21H21.3324L8.98543 3Z'
        fill='#FAFAFA'
      />
    </g>
  </svg>
)

export default XIcon
